import {
  SPARE_CREATE,
  SPARE_FETCH,
  SPARE_UPDATE,
} from '../actions/types';

const INITIAL_STATE = { 
  spares: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
switch (action.type) {
      case SPARE_CREATE:
      case SPARE_UPDATE:
          return { ...state, loading: action.payload }
      case SPARE_FETCH:
          return { ...state, spares: action.payload }
      default:
          return state
  }
}